/** Cấu hình môi trường – đọc một lần, có giá trị mặc định an toàn. */
export const env = {
  apiMode: (import.meta.env.VITE_API_MODE ?? 'mock') as 'mock' | 'http' | 'live',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  /** Gốc API v3 (00 §2.4). Tách biến riêng để màn cũ (v2) vẫn chạy trong lúc chuyển. */
  apiV3BaseUrl: import.meta.env.VITE_API_V3_BASE_URL ?? '/api/v3',
  isDev: import.meta.env.DEV,
  devUsername: import.meta.env.VITE_DEV_USERNAME ?? 'cus1',
  mapTiles: {
    url: import.meta.env.VITE_MAP_TILES_URL,
    attribution: import.meta.env.VITE_MAP_TILES_ATTRIBUTION,
    fallbackUrl: import.meta.env.VITE_MAP_TILES_FALLBACK_URL,
  },
  goongMaptilesKey: import.meta.env.VITE_GOONG_MAPTILES_KEY ?? '',
} as const;

export const isMock = env.apiMode === 'mock';
